import Vue from 'vue'

// 这种方式编辑器没有提示
// const requireComponents = require.context('./', true, /index\.vue/)
// requireComponents.keys().forEach(fileName =>  {
//   const reqCom = requireComponents(fileName)
//   // 截取路径作为组件名
//   // console.log(fileName)
//   const reqComName = reqCom.default.name
//   // 组件挂载
//   Vue.component(reqComName, reqCom.default || reqCom)
// })

import BcEditCommon from '@/components/BusinessComponents/bc-edit-common'
import BcEditOption from '@/components/BusinessComponents/bc-edit-option'
import BcEditStem from '@/components/BusinessComponents/bc-edit-stem'
import BcFileRender from '@/components/BusinessComponents/bc-file-render'
import BcOption from '@/components/BusinessComponents/bc-option'
import BcSelectKnowledgePoint from '@/components/BusinessComponents/bc-select-knowledge-point'
import BcSelectTree from '@/components/BusinessComponents/bc-select-tree'
import BcStandardAnswer from '@/components/BusinessComponents/bc-standard-answer'
import BcSubjectTree from '@/components/BusinessComponents/bc-subject-tree'
import BcUpload from '@/components/BusinessComponents/bc-upload'
import BcViewOption from '@/components/BusinessComponents/bc-view-option'
import BcViewCommon from '@/components/BusinessComponents/bc-view-common'
import BcLineQuestion from '@/components/BusinessComponents/bc-line-question'
import BcLineQuestionView from '@/components/BusinessComponents/bc-line-question/view'
// import BcLogList from '@/components/BusinessComponents/bc-log-list'
import BcQuestionGroupCreate from '@/components/BusinessComponents/bc-question-group/create'
import BcQuestionDetailView from '@/components/BusinessComponents/bc-question-detail-view'
import BcLineQuestionViewLine from '@/components/BusinessComponents/bc-line-question/view-line'
import BcSortQuestionView from '@/components/BusinessComponents/bc-sort-question/view'
import BcSelectQuestion from '@/components/BusinessComponents/bc-select-question'
import BcSelectKnowledgePointTable from '@/components/BusinessComponents/bc-select-knowledge-point-table'
import BcSelectRule from '@/components/BusinessComponents/bc-select-rule'
import BcPreviewTestPaper from '@/components/BusinessComponents/bc-preview-test-paper'
import BcAnswerQuestion from '@/components/BusinessComponents/bc-answer-question'
import BcViewOptionRadio from '@/components/BusinessComponents/bc-view-option/radio'
import BcViewOptionCheckbox from '@/components/BusinessComponents/bc-view-option/checkbox'
import BcLineQuestionAnswer from '@/components/BusinessComponents/bc-line-question/view-line-answer'
import BcAnswerSort from '@/components/BusinessComponents/bc-answer-sort'
import BcAnswerCloze from '@/components/BusinessComponents/bc-answer-cloze'
import BcCountDown from '@/components/BusinessComponents/bc-count-down'
import bcLoadingProgress from '@/components/BusinessComponents/bc-loading-progress'
Vue.component('bc-edit-common', BcEditCommon);
Vue.component('bc-edit-option', BcEditOption);
Vue.component('bc-edit-stem', BcEditStem);
Vue.component('bc-file-render', BcFileRender);
Vue.component('bc-option', BcOption);
Vue.component('bc-select-knowledge-point', BcSelectKnowledgePoint);
Vue.component('bc-select-tree', BcSelectTree);
Vue.component('bc-standard-answer', BcStandardAnswer);
Vue.component('bc-subject-tree', BcSubjectTree);
Vue.component('bc-upload', BcUpload);
Vue.component('bc-view-option', BcViewOption);
Vue.component('bc-view-common', BcViewCommon);
Vue.component('bc-line-question', BcLineQuestion)
Vue.component('bc-line-question-view', BcLineQuestionView)
Vue.component('bc-log-list', () => import('./bc-log-list/index'))
Vue.component('bc-question-group-create', BcQuestionGroupCreate)
Vue.component('bc-question-detail-view', BcQuestionDetailView)
Vue.component('bc-line-question-view-line', BcLineQuestionViewLine)
Vue.component('bc-sort-question-view', BcSortQuestionView)
Vue.component('bc-select-question', BcSelectQuestion)
Vue.component('bc-select-knowledge-point-table', BcSelectKnowledgePointTable)
Vue.component('bc-select-rule', BcSelectRule)
Vue.component('bc-preview-test-paper', BcPreviewTestPaper)
Vue.component('bc-answer-question', BcAnswerQuestion)
Vue.component('bc-view-option-radio', BcViewOptionRadio)
Vue.component('bc-view-option-checkbox', BcViewOptionCheckbox)
Vue.component('bc-line-question-answer', BcLineQuestionAnswer)
Vue.component('bc-answer-sort', BcAnswerSort)

Vue.component('bc-answer-cloze', BcAnswerCloze)
Vue.component('bc-count-down', BcCountDown)
Vue.component('bc-loading-progress', bcLoadingProgress)
